<app-menu-horizontal [menuItems]="menuItems" (onExportClicked)="onExportClicked($event)"></app-menu-horizontal>
<ng-content></ng-content>
